import { Segmented } from './ui';
import { Contrast, Moon, Sun } from './icons';
import { useTheme, type ThemePref } from '../theme/useTheme';

export function ThemeSwitch() {
  const { pref, set } = useTheme();
  return (
    <Segmented<ThemePref>
      value={pref === 'auto' ? (document.documentElement.dataset.theme as ThemePref) : pref}
      onChange={set}
      ariaLabel="Theme"
      options={[
        { value: 'light', label: <Sun width={15} height={15} />, title: 'Light' },
        { value: 'dark', label: <Moon width={15} height={15} />, title: 'Dark' },
        { value: 'hc', label: <Contrast width={15} height={15} />, title: 'High contrast' },
      ]}
    />
  );
}
